import { useParams, Link, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { ArrowLeft, ChevronRight } from 'lucide-react';
import brands from '../data/brands.json';
import ProductCard from '../components/ProductCard';
import FAQ from '../components/FAQ';
import styles from './BrandPage.module.css';

export default function BrandPage() {
  const { brandSlug } = useParams();
  const brand = brands.find((b) => b.slug === brandSlug);

  useEffect(() => { window.scrollTo(0, 0); }, [brandSlug]);

  if (!brand) return <Navigate to="/" replace />;

  return (
    <>
      {/* Brand Hero */}
      <section className={styles.hero} style={{ backgroundImage: `url(${brand.heroImage})` }}>
        <div className={styles.heroOverlay} style={{ background: `linear-gradient(120deg, ${brand.color}dd 0%, ${brand.color}88 60%, transparent 100%)` }} />
        <div className={styles.heroContent}>
          <nav className={styles.breadcrumb}>
            <Link to="/" className={styles.breadLink}>Home</Link>
            <ChevronRight size={14} />
            <Link to="/" className={styles.breadLink}>Brands</Link>
            <ChevronRight size={14} />
            <span>{brand.name}</span>
          </nav>
          {brand.logo ? (
            <img
              src={brand.logo}
              alt={brand.name}
              className={styles.brandLogo}
              onError={(e) => (e.target.style.display = 'none')}
            />
          ) : (
            <div className={styles.brandLogoText}>
              {brand.isFeatured && '⭐ '}{brand.logoFallbackText || brand.name}
            </div>
          )}
          <h1 className={styles.heroTitle}>{brand.name}</h1>
          <p className={styles.heroTagline}>{brand.tagline}</p>
          <p className={styles.heroBrief}>{brand.brief}</p>
        </div>
      </section>

      {/* Products Grid */}
      <section className="section" style={{ background: 'var(--light-bg)' }}>
        <div className="container">
          <div className={styles.sectionHead}>
            <div>
              <p className="section-label">Product Portfolio</p>
              <h2 className="section-title">{brand.name} Products</h2>
            </div>
            <Link to="/" className={styles.backBtn}>
              <ArrowLeft size={15} /> All Brands
            </Link>
          </div>

          <div className={styles.grid}>
            {brand.productCategories.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                brandSlug={brand.slug}
                accentColor={brand.color}
              />
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <FAQ title={`${brand.name} — FAQ`} />
    </>
  );
}
